type BrowserLocation = Pick<
  Location,
  "hostname" | "origin" | "port" | "protocol"
>;

const appointmentDashboardPathPattern =
  /^\/appointmentDashboard(?:\/|[?#]|$)/;

const getAdminOrigin = (browserLocation: BrowserLocation): string => {
  const hostParts = browserLocation.hostname.split(".");
  const isIpv4Address =
    hostParts.length === 4 &&
    hostParts.every((part) => /^\d{1,3}$/.test(part));

  if (hostParts.length < 2 || isIpv4Address) {
    return browserLocation.origin;
  }

  hostParts[0] = "admin";
  const port = browserLocation.port ? `:${browserLocation.port}` : "";
  return `${browserLocation.protocol}//${hostParts.join(".")}${port}`;
};

export const getAdminAppointmentDashboardUrl = (
  appointmentId: string,
  browserLocation: BrowserLocation = window.location,
): string =>
  `${getAdminOrigin(browserLocation)}/appointmentDashboard/${appointmentId}`;

export const resolveAppointmentDashboardTodoLink = (
  link: string,
  browserLocation: BrowserLocation = window.location,
): string => {
  if (!appointmentDashboardPathPattern.test(link)) {
    return link;
  }

  return `${getAdminOrigin(browserLocation)}${link}`;
};
